import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/flow/FlowClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatHeader"] */ "/opt/build/repo/components/chat-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/.pnpm/next@15.3.6_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_react-dom@19.0.0-rc-45804af1-202_5v4fpocwmhqiwqsedpc22vaqzu/node_modules/next/dist/client/app-dir/link.js");
